// Header.js
import React from 'react';
import { Form, Input, Empty, Spin, Popover, Divider, Avatar } from 'antd';

import { UserOutlined } from '@ant-design/icons'

import Title from './Title';
import HeaderMenu from './HeaderMenu';
import Location from './Location';

import Config from '../config/Config';
import EventBus from './eventBus';
import WidgetAjax from './../widget/WidgetAjax';
import Widget from '../widget/Widget';
import WidgetAES from '../widget/WidgetAES';
import WidgetModal from './../widget/WidgetModal';
import WidgetMessage from './../widget/WidgetMessage';
import NoData from '../pages/com/NoData';
// import 'antd/dist/antd.css';
import '../css/header.scss'


let filePath = Config.getFilePath();
let application = Config.getApplication();
let enterpriseUrl = Config.getEnterpriseUrl();


class Header extends React.Component {
	constructor(props) {
		super(props);
		this.refTest = React.createRef();
		// 订阅事件总线上的特定事件

		this.state = {
			user_info: {},
			realname: undefined,
			location: undefined,
			modification: false,
			editRroupModelOptions: {
				title: "用户详情",
				confirm: "确定",
				okText: '修改'
			},
			editRpasswordOptions: {
				title: "修改密码",
				confirm: "确定",
			},
			data: [],
			total: 0,
			loading: false,
			page: 1,
			records: 5,
			isreadcount: '0',
			noreadcount: 0,
			isBindGZH: true,
			entInfo: {},
			userMenu: [
				{ name: '个人中心', tips: '查看我的求职反馈信息', redirection: 'personalCenter' },
				// { name: '我的职业规划',redirection: 'personal_planning' },
				{ name: '账号设置', redirection: 'account_setting' }
			]
		}
		this.bindRef = null;
		this.freshPage = this.freshPage.bind(this);

		this.headerMenuOnSelect = this.headerMenuOnSelect.bind(this);
		// this.modificationMethod = this.modificationMethod.bind(this);
		this.intervalId = null; // 用于存储定时器ID
		this.logout = this.logout.bind(this);
		this.onLogout = this.onLogout.bind(this);
		// this.userInfo = this.userInfo.bind(this);
	}

	componentDidMount() {
		const access = sessionStorage.getItem("_user_access_");

		if (access) {
			this.getUserInfo();
			this.setState({ access: access })

			// 设置定时器，每5秒调用一次API
			this.loadData();
			this.intervalId = setInterval(() => {
				this.loadData();
			}, 5000)
		}

		;

		// document.addEventListener('mousedown', (e) => this.handleClickOutside(e), false);
		// EventBus.on('bodyDataChanged', this.handleBodyDataChange);
	}


	componentWillUnmount() {
		this.stopPolling()
		// 在组件卸载时，取消订阅事件，避免内存泄漏
		// EventBus.off('bodyDataChanged', this.handleBodyDataChange);
	}

	// 停止轮询
	stopPolling() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
			this.intervalId = null;
		}
	}

	getUserInfo = () => {

		const onGetUser = (res) => {

			if (res.status == 0) {
				this.setState({ user_info: res.result })
			}
		}
		const onInfo = (res) => {

			if (res.status === 0) {
				if (res.result && res.result.extensions) {
					let data = res.result.extensions;

					sessionStorage.setItem("_user_info_", JSON.stringify(res.result));

					this.setState({ user_info: res.result });
					this.getUser();
					if (!data.openid) {
						// this.bindRef.open();
						this.setState({ isBindGZH: false })
					}
				}
				else {
					this.setState({ isBindGZH: false })
					// this.bindRef.open();
				}
			}
		}

		WidgetAjax.ajax({ url: Config.getBasePath() + "/info", callback: onInfo })
	}

	getUser = () => {
    const onUserInfo = (res) => {
      if (res.status == 0) {
        this.setState({ user: res.result });
      }
    }
    WidgetAjax.ajax({ url: Config.getBasePath() + '/applicant/resume_info', params: {}, callback: onUserInfo });

  }


	handleBodyDataChange = (e, v) => {
		this.messageCount();
		this.loadData();
	}

	isBindOpenid = () => {

		sessionStorage.setItem("bindShow", 1)

		WidgetAjax.ajax({
			url: Config.getBasePath() + "/weixin/bind_check", params: { application },
			callback: (res) => {

				if (res.status == 0) {

					if (res.result && res.result.openid) {
						this.setState({ isBindGZH: false });
					}
					else {
						this.setState({ isBindGZH: true });
						// setTimeout(() => {
						// 	this.bindRef.open();
						// }, 1500);
					}
				}
			},
		});
	}

	onMouseOver = (e) => {

		this.setState({ PopoverOpen: true });
	}

	handleClickOutside(event) {

		this.setState({ PopoverOpen: false });

	}
	handleNotificationClick = (event) => {
		event.stopPropagation();
	};

	handleClick = () => {
		this.setState({ modification: !this.state.modification });
	};

	messageCount = () => {

		const onMessageCount = async (res) => {

			if (res.status == 0) {
				if (res.results && res.results.length > 0) {
					let item = res.results.find((item) => item.state == 0)

					if (item) {
						await this.setState({ noreadcount: item?.count })
					}
					else {
						await this.setState({ noreadcount: 0 })
					}

					if (item > 0) {
						this.setState({ modification: true })
					}
					else {
						this.setState({ modification: false })
					}
				}
			}
		}

		WidgetAjax.ajax({ url: Config.getBasePath() + "/message/summary", callback: onMessageCount });
	}

	/**
	* 公司详情
	*/
	enterpriseInfo = () => {

		const onEnterpriseInfo = (res) => {

			if (res.status == 0) {
				this.setState({ entInfo: res.result });
			}
		}
		WidgetAjax.ajax({ url: Config.getBasePath() + "/enterprise/info", callback: onEnterpriseInfo });
	}

	/**
	 * 列表数据
	 */
	loadData = () => {
		const { records, page } = this.state;
		this.setState({ loading: true });
		const onLoadData = (res) => {
			if (res.status === 0) {
				this.setState({ mesData: res.results, total: res.total });
			}
			else {
				this.setState({ data: [], total: 0 })
			}
			this.setState({ loading: false })
		}
		WidgetAjax.ajax({ url: Config.getBasePath() + "/message/list", params: { page, records, states: ['0'] }, callback: onLoadData });
	}



	/**
	 * 全部已读
	 */
	upisreadAll = () => {
		const onUpisreadAll = (res) => {
			if (res.status == 0) {
				EventBus.emit('bodyDataChanged', "未读更新");
				this.messageCount();
				this.loadData();
			}
		}
		WidgetAjax.ajax({ url: Config.getBasePath() + "/message/receive", callback: onUpisreadAll });
	}



	headerMenuOnSelect(key) {

		if (this.props.headerOnSelect !== undefined) {
			this.props.headerOnSelect(key);
		}
	}

	freshPage() {
		if (this.props.freshPage !== undefined) {
			this.props.freshPage();
		}
	}

	logout() {
		WidgetAjax.ajax({ url: Config.getBasePath() + '/logout', params: undefined, callback: this.onLogout });
	}

	onLogout(result, params) {

		if (result.status === 0) {
			sessionStorage.removeItem("_user_access_");
			sessionStorage.removeItem("_user_info_");
			sessionStorage.removeItem("_user_login_info_");

			if (this.props.redrict !== undefined) {
				this.props.redrict("/login", undefined, true);
			}
		}
		else {
			sessionStorage.removeItem("_user_access_");
			sessionStorage.removeItem("_user_info_");
			sessionStorage.removeItem("_user_login_info_");

			WidgetMessage.error(result.message);

			if (this.props.redrict !== undefined) {
				this.props.redrict("/login", undefined, true);
			}

		}

		sessionStorage.removeItem("bindShow");
	}



	onUser(type) {

		this.setState({ modification: false });

		switch (type) {
			case "details":
				{
					this.editGroupModelRef.open();
					break;
				}
			case "password":
				{
					this.state.editRpasswordOptions['isVisible'] = true;
					this.editRpassworRef.open();
					break;
				}
		}
	}

	roupModel = () => {

		let { remark, cell, email } = this.state

		let params = {
			realname: remark,
			cell: cell,
			email: email
		}

		const onRoupModel = (result) => {

			if (result.status === 0) {
				WidgetMessage.success("用户修改成功！");
				this.logout();
			}
			else {
				WidgetMessage.error("用户修改失败！" + result.message);
			}
		}
		WidgetAjax.ajax({ url: Config.getBasePath() + '/update_info', params: params, callback: onRoupModel });
	}



	password = () => {

		let { new_password, old_password } = this.state;

		this.form.validateFields().then((value) => {

			this.state.editRpasswordOptions['isVisible'] = false;
			this.setState({ isVisible: true });
			let nonce = Widget.randomString(6, true);

			let oldPasswordEncryption = this.$md5("ES_6ps" + old_password + "_N3tM").toUpperCase();
			let newPasswordEncryption = WidgetAES.encryptPassword(new_password, nonce);

			let params = {
				old_password: oldPasswordEncryption,
				new_password: newPasswordEncryption + nonce
			}

			const onPassword = (result) => {

				if (result.status === 0) {
					WidgetMessage.success("密码修改成功！");
					this.logout();
				}
				else {
					WidgetMessage.error("密码修改失败" + result.message);
				}
			}
			WidgetAjax.ajax({ url: Config.getBasePath() + '/update_password', params: params, callback: onPassword });

		})
	}


	// /**
	// * 未读更新
	// */
	// upisread = (ID) => {

	// 	const onUpisread = (res) => {
	// 		if (res.status == 0) {
	// 			EventBus.emit('bodyDataChanged', "未读更新");
	// 			this.messageCount();
	// 			this.loadData();
	// 		}
	// 	}

	// 	WidgetAjax.ajax({ url: Config.getBasePath() + "/message/receive", params: { id: ID }, callback: onUpisread });
	// }

	onClickInfo = (data) => {
		if (data && data.id) this.upisread(data.id)
		this.props.history.children.props.history.push({ pathname: '/home/job_manager/job_info', state: { data } });
		this.setState({ modification: false });

	}

	notify = (type) => {


		switch (type) {
			case "enterprise_login":
				{
					window.location.href = enterpriseUrl+'/enterprise/login' ;
					break;
				}
			case "enterprise_register":
				{
					window.location.href = enterpriseUrl+'/enterprise/login?tab=2' ;
					break;
				}
			case "applicant_login":
				{
					this.props.history.push({ pathname: "/login" });
					window.location.reload();
					break;
				}
			default:
				{
					this.props.history.push({ pathname: `/home/${type}` });
					break;
				}

			// case "personalCenter":
			// 	{
			// 		this.props.history.push({ pathname: "/home/personalCenter" });
			// 		break;
			// 	}
			// case "resume":
			// 	{
			// 		this.props.history.push({ pathname: "/home/resume" });
			// 		break;
			// 	}
			// case "account_setting":
			// 	{
			// 		this.props.history.push({ pathname: "/home/account_setting" });
			// 		break;
			// 	}
			// case "personal_planning":
			// 	{
			// 		this.props.history.push({ pathname: "/home/personal_planning" });
			// 		break;
			// 	}


		}
	}

	locationNotify = (location) => {
		this.setState({ location: location });
	}

	exchange = () => {

	}

	componentWillReceiveProps(nextProps) {
		// console.log(nextProps, 'nextProps');
	}


	render() {
		const { activeKey, titleNode, location: frameLocation } = this.props;
		const { access, user_info = {}, user={}, mesData = [], userMenu } = this.state;

		let mes_data = mesData

		let mes_box = <div className='user-menu-mes-popover'>
			<span className='mes-head'><span className='mes_title'>未读</span>	<a className='mes_op' onClick={() => this.upisreadAll()}>全部标为已读</a></span>
			{
				mes_data && mes_data.length > 0 ?
					<ul className='mes_list'>
						{mes_data.map((item) => {
							return <li className='mes_list_item'><span className='list_item_content'>{item?.message}</span><span className='list_item_date'>{item?.issue_time}</span></li>
						})}
					</ul> : <NoData width={100} height={100} />
			}
			<div className='mes_op_all' onClick={() => { this.props.history.push({ pathname: "/home/MessageCenter" }) }} >查看全部</div>
		</div>

		return (

			<div className='sf-top'>


				<div className="sf-title-right sd-title-right sg-title-right">

					<div className='sf-top-left'>
						{ //首页不显示头部 LOGO
							activeKey === 'homePage'  ? null :
								<div className='sf-top-logo'><img src={require("../img/pinzhunzhun/login/logo.svg")} /></div>
						}

						<div className="sf-title-menu">
							<Location notify={this.locationNotify} />
							<HeaderMenu titleNode={titleNode} activeKey={activeKey} onSelect={this.headerMenuOnSelect} />
						</div>
					</div>


					<div className="logout" >
						{
							access ? <div className='user-menu'>

								<div className='user-menu-item'>
									<Popover placement="bottomLeft" content={mes_box}>	消息</Popover>
								</div>

								<div className='user-menu-item' onClick={() => { this.notify("resume") }}>简历</div>
							</div> : null
						}

						{
							access ?
								<>
									<Popover
										// open={true}
										content={
											<div className='sg-AvatarBox'>
												{
													userMenu && userMenu.map((item) => {
														return <div onClick={() => { this.notify(item?.redirection) }} className="cursor-pointer sf-avatar-box-item">
															{item?.name}
															{
																item?.tips ? <span className='sf-avatar-box-tips'>{item?.tips}</span> : null
															}
														</div>
													})
												}
												<Divider className="sf-divider" />
												<div className='sg-AvatarBotton' >
													<div className="cursor-pointer sf-avatar-box-logout" onClick={this.logout}>退出登录</div>
												</div>

											</div>
										}
										className='sg-PopoverAvatar'
										placement="bottomLeft"
									>
										<div className='sg-Avatar right-logo'>
											<span className="sf-user-realname">{user_info.realname}</span>

											{
												user && user.LOGO ?
													<img className='user_logo' src={filePath + '/applicant/'+ user?.id +'/M' + user?.LOGO[0] + '.png'} />
													: <Avatar  size={32} icon={<UserOutlined />} />
											}
											{/* <Avatar size={32} icon={<UserOutlined />} /> */}
										</div>
									</Popover>
								</> :

								<>
									<div className="cursor-pointer sf-right-menu-item" onClick={() => { this.notify("enterprise_login") }}>企业登录</div>
									<div className="cursor-pointer sf-right-menu-item" onClick={() => { this.notify("enterprise_register") }}>企业注册</div>
									<div className="cursor-pointer sf-right-menu-item" onClick={() => { this.notify("applicant_login") }}>人才登录/注册</div>
								</>
						} 
						<div className="cursor-pointer sf-right-menu-item">
							{/* // onClick={() => { this.notify("phone") }} */}
							<Popover
								content={
									<div className='sg-PopoverMobile '>
										<div className='sg-mobileBox'>
											<div className='sf-page-tool-between'>
												<div className='mobile_item'>
													<img className='codeImg' src={require("../img/pinzhunzhun/dataSource/applet_job.png")} />
													<div className='mobile_itemTips'>招聘求职找工作</div>
												</div>

												<div className='mobile_item'>
													<img className='codeImg' src={require("../img/pinzhunzhun/dataSource/applet.png")} />
													<div className='mobile_itemTips'>零工任务接单平台</div>
												</div>
											</div>

										</div>
									</div>
								}
								placement="bottomLeft"
							>
								<img src={require("../img/frame/phone.png")}></img>
								移动端
							</Popover>

						</div>
					</div>
				</div>

			</div >
		)
	}
}

export default Header

// export const Location = ({ location }) => {
// 	if (location !== undefined) {
// 		return (
// 			<div style={{ float: 'left' }}>
// 				<img className="headimg" src={require('../img/frame/location.svg')} alt="es-lint want to get"></img>
// 				<span style={{ padding: '10px', fontSize: '14px' }}>{location}</span>
// 				<span style={{ paddingRight: '10px', color: '#999', fontWeight: 'bold' }}>|</span>
// 			</div>
// 		)
// 	}
// 	else {
// 		return <></>;
// 	}
// }